import React from 'react';

// BayesPrep Student Portal Logo Component - Following Style Guide
interface StudentLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  textColor?: 'default' | 'white';
}

const StudentLogo: React.FC<StudentLogoProps> = ({
  size = 'md',
  showText = false,
  className = '',
  textColor = 'default'
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  const getTextColorClass = () => {
    switch (textColor) {
      case 'white':
        return 'text-white';
      default:
        return 'text-gray-900';
    }
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* BayesPrep Logo - Green rounded square with BR */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          {/* Blue rounded square background */}
          <rect x="4" y="4" width="56" height="56" rx="12" fill="#0456FF"/>

          {/* BP Text - BayesPrep */}
          <text
            x="32"
            y="42"
            textAnchor="middle"
            fontSize="26"
            fontWeight="700"
            fontFamily="Source Sans Pro, sans-serif"
            fill="#ffffff"
          >
            BP
          </text>
        </svg>
      </div>

      {/* Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`font-heading font-bold leading-tight ${textSizeClasses[size]} ${getTextColorClass()}`}>
            bayes prep
          </span>
          <span className={`font-body font-medium leading-tight ${size === 'sm' ? 'text-xs' : 'text-sm'} ${
            textColor === 'white' ? 'text-white opacity-90' : 'text-gray-600'
          }`}>
            Student Portal
          </span>
        </div>
      )}
    </div>
  );
};

export default StudentLogo;
